/* =============================================
   JUICE BEAUTY UX FIXES - JavaScript
      Fix 3B: Star Rating Accessibility
         Fix 4A: PDP Accordion Reorder
            Fix 4B: Reviews Anchor Link
               ============================================= */

               (function juiceUXFixes() {

                 /* --- FIX 3B: Normalize star rating aria-labels --- */
                   function normalizeStarRatings() {
                       var unicodeStarSpans = document.querySelectorAll('.juice-featured-products__stars');
                           unicodeStarSpans.forEach(function(span) {
                                 var stars = span.textContent.trim();
                                       var fullCount = (stars.match(/\u2605/g) || []).length;
                                             var halfCount = (stars.match(/\u00bd/g) || []).length;
                                                   var rating = fullCount + halfCount * 0.5;
                                                         span.setAttribute('aria-label', rating + ' out of 5 stars');
                                                               span.setAttribute('role', 'img');
                                                                     span.setAttribute('title', rating + ' out of 5 stars');
                                                                         });
                                                                             var cssStarSpans = document.querySelectorAll('.juice-featured-products__rating');
                                                                                 cssStarSpans.forEach(function(span) {
                                                                                       if (!span.getAttribute('role')) {
                                                                                               span.setAttribute('role', 'img');
                                                                                                     }
                                                                                                         });
                                                                                                           }

                                                                                                             /* --- FIX 4A: Reorder PDP Accordions --- */
                                                                                                               function reorderPDPAccordions() {
                                                                                                                   var container = document.querySelector('.juice-pdp__accordions');
                                                                                                                       if (!container) return;
                                                                                                                           var accordions = Array.from(container.querySelectorAll(':scope > .juice-pdp__accordion'));
                                                                                                                               if (!accordions.length) return;
                                                                                                                                   var desiredOrder = ['benefits', 'how to use', 'ingredients', 'product details', 'clinical', 'recycling'];
                                                                                                                                       var sorted = desiredOrder.map(function(keyword) {
                                                                                                                                             return accordions.find(function(acc) {
                                                                                                                                                     var trigger = acc.querySelector('.juice-pdp__accordion-trigger');
                                                                                                                                                             return trigger && trigger.textContent.toLowerCase().includes(keyword);
                                                                                                                                                                   });
                                                                                                                                                                       }).filter(Boolean);
                                                                                                                                                                           var unmatched = accordions.filter(function(acc) { return !sorted.includes(acc); });
                                                                                                                                                                               sorted.concat(unmatched).forEach(function(acc) { container.appendChild(acc); });
                                                                                                                                                                                 }

                                                                                                                                                                                   /* --- FIX 4B: Reviews anchor jump link --- */
                                                                                                                                                                                     function addReviewsAnchor() {
                                                                                                                                                                                         var reviewsWidget = document.querySelector('.yotpo-font, [class*="yotpo"], #shopify-section-reviews');
                                                                                                                                                                                             if (reviewsWidget && !reviewsWidget.id) {
                                                                                                                                                                                                   reviewsWidget.id = 'product-reviews';
                                                                                                                                                                                                       }
                                                                                                                                                                                                           var reviewCountEl = document.querySelector('.yotpo-widget-instance');
                                                                                                                                                                                                               if (reviewCountEl && reviewsWidget) {
                                                                                                                                                                                                                     reviewCountEl.style.cursor = 'pointer';
                                                                                                                                                                                                                           reviewCountEl.setAttribute('title', 'Jump to customer reviews');
                                                                                                                                                                                                                                 reviewCountEl.setAttribute('role', 'link');
                                                                                                                                                                                                                                       reviewCountEl.setAttribute('tabindex', '0');
                                                                                                                                                                                                                                             reviewCountEl.addEventListener('click', function() {
                                                                                                                                                                                                                                                     var target = document.getElementById('product-reviews');
                                                                                                                                                                                                                                                             if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                                                                                                                                                                                                                                   });
                                                                                                                                                                                                                                                                         reviewCountEl.addEventListener('keydown', function(e) {
                                                                                                                                                                                                                                                                                 if (e.key === 'Enter' || e.key === ' ') {
                                                                                                                                                                                                                                                                                           e.preventDefault();
                                                                                                                                                                                                                                                                                                     var target = document.getElementById('product-reviews');
                                                                                                                                                                                                                                                                                                               if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                                                                                                                                                                                                                                                                                       }
                                                                                                                                                                                                                                                                                                                             });
                                                                                                                                                                                                                                                                                                                                 }
                                                                                                                                                                                                                                                                                                                                   }

                                                                                                                                                                                                                                                                                                                                     /* --- Run all fixes on DOM ready --- */
                                                                                                                                                                                                                                                                                                                                       function init() {
                                                                                                                                                                                                                                                                                                                                           normalizeStarRatings();
                                                                                                                                                                                                                                                                                                                                               reorderPDPAccordions();
                                                                                                                                                                                                                                                                                                                                                   addReviewsAnchor();
                                                                                                                                                                                                                                                                                                                                                     }

                                                                                                                                                                                                                                                                                                                                                       if (document.readyState === 'loading') {
                                                                                                                                                                                                                                                                                                                                                           document.addEventListener('DOMContentLoaded', init);
                                                                                                                                                                                                                                                                                                                                                             } else {
                                                                                                                                                                                                                                                                                                                                                                 init();
                                                                                                                                                                                                                                                                                                                                                                   }

                                                                                                                                                                                                                                                                                                                                                                   })();

// ============================================================
// JUICE BEAUTY UX FIXES - BATCH 2 JS
// ============================================================

(function() {
  'use strict';

  // Fix B1: Add alt text to category images that are missing alt attributes
  function fixCategoryImageAltText() {
    const categoryLinks = document.querySelectorAll('.shop-category__image-link');
    const categoryLabels = [];
    
    // Get category names from sibling elements
    categoryLinks.forEach(link => {
      const parent = link.closest('[class*="shop-category"], [class*="category-item"]') || link.parentElement;
      // Look for the category title in sibling elements
      const titleEl = parent?.querySelector('[class*="title"], [class*="label"], h2, h3, h4') || 
                      parent?.nextElementSibling?.querySelector('h2, h3, h4');
      const titleText = titleEl?.textContent?.trim();
      
      const img = link.querySelector('img');
      if (img && (!img.alt || img.alt.trim() === '')) {
        if (titleText) {
          img.setAttribute('alt', titleText + ' Collection');
        } else {
          // Try getting from the link text or category context
          const allText = parent?.textContent?.trim();
          if (allText && allText.length < 40) {
            img.setAttribute('alt', allText.trim() + ' Collection');
          }
        }
      }
    });
    
    // Also handle shop-category sections where title is outside the link
    const catSections = document.querySelectorAll('[class*="shop-category"]');
    catSections.forEach(section => {
      const img = section.querySelector('img');
      const titleEl = section.querySelector('[class*="title"], [class*="label"], .shop-category__name, h2, h3');
      
      if (img && (!img.alt || img.alt.trim() === '') && titleEl) {
        const altText = titleEl.textContent.trim();
        if (altText) {
          img.setAttribute('alt', altText + ' Products');
        }
      }
    });
  }

  // Fix B2: Smooth scroll for review anchor links
  function fixReviewAnchorScroll() {
    // Find review count/rating links that anchor to reviews section
    const reviewLinks = document.querySelectorAll(
      'a[href*="yotpo-reviews"], a[href*="product-reviews"], a[href*="reviews"], .juice-pdp__rating'
    );
    
    reviewLinks.forEach(link => {
      if (!link.href && !link.getAttribute('href')) return;
      const href = link.href || link.getAttribute('href') || '';
      const hashIdx = href.indexOf('#');
      if (hashIdx === -1) return;
      
      const targetId = href.slice(hashIdx + 1);
      const targetEl = document.getElementById(targetId);
      
      if (targetEl) {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const headerHeight = document.querySelector('.site-header, header, .juice-header-nav')?.offsetHeight || 80;
          const targetTop = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;
          window.scrollTo({ top: targetTop, behavior: 'smooth' });
        }, { passive: false });
      }
    });
  }

  // Fix B3: Normalize star rating display across product cards
  // Ensure both .juice-featured-products__stars and .juice-featured-products__rating
  // cards display stars at the same visual size and color
  function normalizeStarRatings() {
    // For cards using the rating class with star spans
    const ratingEls = document.querySelectorAll('.juice-featured-products__rating');
    ratingEls.forEach(el => {
      const stars = el.querySelectorAll('.juice-featured-products__star');
      stars.forEach(star => {
        // Remove any inline background-color that creates dark boxes
        star.style.backgroundColor = 'transparent';
        star.style.display = 'inline-block';
      });
    });
    
    // Also normalize the text-based star elements
    const textStars = document.querySelectorAll('.juice-featured-products__stars');
    textStars.forEach(el => {
      el.style.fontSize = '14px';
    });
  }

  // Fix B4: Add review count text more prominently to PDP ratings
  function enhancePdpRating() {
    const pdpRating = document.querySelector('.juice-pdp__rating');
    if (pdpRating) {
      const reviewText = pdpRating.textContent.trim();
      if (reviewText && !pdpRating.getAttribute('aria-label')) {
        pdpRating.setAttribute('aria-label', 'Customer reviews: ' + reviewText + '. Click to read reviews.');
        pdpRating.setAttribute('title', 'Click to read reviews');
      }
    }
  }

  // Run all fixes
  function runBatch2Fixes() {
    fixCategoryImageAltText();
    fixReviewAnchorScroll();
    normalizeStarRatings();
    enhancePdpRating();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBatch2Fixes);
  } else {
    runBatch2Fixes();
  }
  
  // Also run after a short delay to handle dynamically loaded content
  setTimeout(runBatch2Fixes, 1500);
  setTimeout(runBatch2Fixes, 3000);

})();

// ============================================================
// BATCH 3: PRODUCT CARDS, MEGA MENU KEYBOARD NAV, FOOTER UX
// ============================================================

(function() {
  'use strict';

  // 3-A: Product card keyboard accessibility - enhance aria labels
  function enhanceProductCardKeyboard() {
    const cards = document.querySelectorAll('.juice-product-card');
    cards.forEach(card => {
      const btn = card.querySelector('.juice-product-card__button, .juice-hover-button');
      const link = card.querySelector('.juice-product-card__image-link');
      if (btn && !btn.dataset.juice3Enhanced) {
        btn.dataset.juice3Enhanced = '1';
        const btnText = btn.textContent.trim();
        const titleEl = card.querySelector('.juice-product-card__title');
        const productName = titleEl ? titleEl.textContent.trim() : '';
        if (productName && !btn.getAttribute('aria-label')) {
          btn.setAttribute('aria-label', btnText + ': ' + productName);
        }
      }
      if (link && !link.dataset.juice3Enhanced) {
        link.dataset.juice3Enhanced = '1';
        const titleEl = card.querySelector('.juice-product-card__title');
        const productName = titleEl ? titleEl.textContent.trim() : '';
        if (productName && !link.getAttribute('aria-label')) {
          link.setAttribute('aria-label', 'View ' + productName);
        }
      }
    });
  }

  // 3-B: Mega menu keyboard navigation (Tab/Arrow support)
  function enhanceMegaMenuKeyboard() {
    const navItems = document.querySelectorAll('.juice-header-nav__item');
    navItems.forEach(item => {
      if (item.dataset.juice3MegaKb) return;
      item.dataset.juice3MegaKb = '1';
      const trigger = item.querySelector('.juice-header-nav__trigger');
      const mega = item.querySelector('.juice-mega');
      if (!trigger || !mega) return;
      if (!trigger.getAttribute('tabindex')) {
        trigger.setAttribute('tabindex', '0');
      }
      if (trigger.tagName !== 'BUTTON' && trigger.tagName !== 'A') {
        trigger.setAttribute('role', 'button');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'true');
      }
      trigger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          const isOpen = mega.classList.contains('is-open');
          if (isOpen) {
            mega.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
          } else {
            mega.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            const firstLink = mega.querySelector('a');
            if (firstLink) firstLink.focus();
          }
        }
        if (e.key === 'Escape') {
          mega.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });
  }

  // 3-C: Footer newsletter - enhanced UX feedback
  function enhanceFooterNewsletter() {
    const form = document.querySelector('.juice-footer__form');
    const input = document.querySelector('.juice-footer__input');
    const submitBtn = document.querySelector('.juice-footer__submit');
    if (!form || !input || input.dataset.juice3Enhanced) return;
    input.dataset.juice3Enhanced = '1';
    const field = document.querySelector('.juice-footer__field');
    if (field && input) {
      input.addEventListener('focus', function() {
        field.style.borderColor = 'rgb(100, 120, 50)';
        field.style.boxShadow = '0 0 0 2px rgba(200, 205, 60, 0.25)';
      });
      input.addEventListener('blur', function() {
        field.style.borderColor = 'rgb(0, 0, 0)';
        field.style.boxShadow = 'none';
      });
    }
    if (submitBtn && !submitBtn.getAttribute('aria-label')) {
      submitBtn.setAttribute('aria-label', 'Subscribe to newsletter');
    }
  }

  // 3-D: Collection grid - ensure row gap is applied
  function normalizeCollectionCardHeights() {
    const grid = document.querySelector('.juice-collection__grid');
    if (!grid) return;
    const computed = getComputedStyle(grid);
    if (computed.rowGap === 'normal' || computed.rowGap === '0px') {
      grid.style.rowGap = '40px';
    }
  }

  // 3-E: Fix footer whitespace
  function fixFooterWhitespace() {
    const footerInner = document.querySelector('.juice-footer__inner');
    if (footerInner) {
      const computed = window.getComputedStyle(footerInner);
      if (parseFloat(computed.paddingBottom) > 40) {
        footerInner.style.paddingBottom = '0';
      }
    }
  }

  function runBatch3() {
    enhanceProductCardKeyboard();
    enhanceMegaMenuKeyboard();
    enhanceFooterNewsletter();
    normalizeCollectionCardHeights();
    fixFooterWhitespace();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBatch3);
  } else {
    runBatch3();
  }

  // Re-run on dynamic content changes (e.g. pagination / AJAX)
  var _b3Observer = new MutationObserver(function(mutations) {
    var hasNewCards = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && (
          (node.classList && node.classList.contains('juice-product-card')) ||
          (node.querySelector && node.querySelector('.juice-product-card'))
        )) {
          hasNewCards = true;
        }
      });
    });
    if (hasNewCards) {
      enhanceProductCardKeyboard();
      normalizeCollectionCardHeights();
    }
  });
  _b3Observer.observe(document.body, { childList: true, subtree: true });

})();


// ============================================================
// BATCH 4: MOBILE RESPONSIVENESS, PDP GALLERY ZOOM, QUIZ CTA
// ============================================================

(function() {
  'use strict';

  function initPDPGalleryZoom() {
    var slides = document.querySelectorAll('.juice-pdp__slide');
    slides.forEach(function(slide) {
      if (slide.dataset.juice4Zoom) return;
      slide.dataset.juice4Zoom = '1';
      var img = slide.querySelector('.juice-pdp__image');
      if (img && img.alt) {
        slide.setAttribute('role', 'img');
        slide.setAttribute('aria-label', 'Product image: ' + img.alt);
      }
    });
  }

  function initPDPThumbnailKeyboard() {
    var thumbs = document.querySelectorAll('.juice-pdp__thumb');
    thumbs.forEach(function(thumb, index) {
      if (thumb.dataset.juice4Kb) return;
      thumb.dataset.juice4Kb = '1';
      if (!thumb.getAttribute('tabindex')) thumb.setAttribute('tabindex', '0');
      if (!thumb.getAttribute('role')) thumb.setAttribute('role', 'button');
      if (!thumb.getAttribute('aria-label')) thumb.setAttribute('aria-label', 'View product image ' + (index + 1));
      thumb.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); thumb.click(); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var next = thumbs[index + 1]; if (next) { next.focus(); next.click(); } }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var prev = thumbs[index - 1]; if (prev) { prev.focus(); prev.click(); } }
      });
    });
  }

  function initQuizBannerHover() {
    var quizMedia = document.querySelector('.skincare-quiz-banner__media');
    if (!quizMedia || quizMedia.dataset.juice4Quiz) return;
    quizMedia.dataset.juice4Quiz = '1';
    if (!quizMedia.getAttribute('aria-label')) {
      quizMedia.setAttribute('aria-label', 'Take the Skincare Quiz to find your solution');
    }
  }

  function fixMobileFooterField() {
    var field = document.querySelector('.juice-footer__field');
    var input = document.querySelector('.juice-footer__input');
    if (!field || !input || field.dataset.juice4Mobile) return;
    field.dataset.juice4Mobile = '1';
    function adjust() {
      if (window.innerWidth <= 989) {
        field.style.boxSizing = 'border-box';
        field.style.width = '100%';
        input.style.minWidth = '0';
        input.style.flex = '1';
      }
    }
    adjust();
    window.addEventListener('resize', adjust, { passive: true });
  }

  function initFeaturedProductsScrollSnap() {
    var scroller = document.querySelector('.juice-featured-products__scroller');
    if (!scroller || scroller.dataset.juice4Snap) return;
    scroller.dataset.juice4Snap = '1';
    if (window.innerWidth <= 768) {
      scroller.style.scrollSnapType = 'x mandatory';
      var cards = scroller.querySelectorAll('.juice-featured-products__card');
      cards.forEach(function(card) { card.style.scrollSnapAlign = 'start'; });
    }
  }

  function improveMobileTouchTargets() {
    var backBtns = document.querySelectorAll('.juice-mobile-menu__back');
    backBtns.forEach(function(btn) {
      if (!btn.dataset.juice4Touch) {
        btn.dataset.juice4Touch = '1';
        btn.style.minHeight = '44px';
        btn.style.display = 'flex';
        btn.style.alignItems = 'center';
      }
    });
  }

  function runBatch4() {
    initPDPGalleryZoom();
    initPDPThumbnailKeyboard();
    initQuizBannerHover();
    fixMobileFooterField();
    initFeaturedProductsScrollSnap();
    improveMobileTouchTargets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBatch4);
  } else {
    runBatch4();
  }

  var _b4Observer = new MutationObserver(function(mutations) {
    var shouldRerun = false;
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.querySelector && (
          node.querySelector('.juice-pdp__slide') ||
          node.querySelector('.juice-pdp__thumb') ||
          node.querySelector('.skincare-quiz-banner')
        )) shouldRerun = true;
      });
    });
    if (shouldRerun) runBatch4();
  });
  _b4Observer.observe(document.body, { childList: true, subtree: true });

})();


// ============================================================
// BATCH 5: TYPOGRAPHY, CATEGORY HOVER, ACCESSIBILITY POLISH
// ============================================================

(function() {
  'use strict';

  function fixRemainingAltText() {
    var featuredImgs = document.querySelectorAll('.juice-featured-products__image');
    featuredImgs.forEach(function(img) {
      if (!img.alt || img.alt === '') {
        var card = img.closest('.juice-featured-products__card');
        if (card) {
          var titleEl = card.querySelector('.juice-featured-products__title');
          if (titleEl) img.alt = titleEl.textContent.trim() + ' by Juice Beauty';
        }
      }
    });
    var footerLogo = document.querySelector('.juice-footer__logo');
    if (footerLogo && (!footerLogo.alt || footerLogo.alt === '')) {
      footerLogo.alt = 'Juice Beauty — Juice In. Junk Out.';
    }
  }

  function enhanceCategoryHover() {
    var catItems = document.querySelectorAll('.shop-category__item');
    catItems.forEach(function(item) {
      if (item.dataset.juice5Cat) return;
      item.dataset.juice5Cat = '1';
      var imgLink = item.querySelector('.shop-category__image-link');
      if (imgLink) {
        var title = item.querySelector('.shop-category__title');
        if (title && !imgLink.getAttribute('aria-label')) {
          imgLink.setAttribute('aria-label', 'Shop ' + title.textContent.trim());
        }
      }
    });
  }

  function fixCartPageLinks() {
    var cartEmptyLinks = document.querySelectorAll('.cart--empty a');
    cartEmptyLinks.forEach(function(link) {
      if (!link.dataset.juice5Cart) {
        link.dataset.juice5Cart = '1';
        link.style.color = 'rgb(0, 0, 0)';
      }
    });
  }

  function enhanceAnnouncementBar() {
    var annBar = document.querySelector('.announcement-bar');
    if (annBar && !annBar.dataset.juice5Ann) {
      annBar.dataset.juice5Ann = '1';
      var text = annBar.textContent.trim().substring(0, 100);
      if (!annBar.getAttribute('aria-label')) {
        annBar.setAttribute('aria-label', 'Announcement: ' + text);
      }
    }
  }

  function runBatch5() {
    fixRemainingAltText();
    enhanceCategoryHover();
    fixCartPageLinks();
    enhanceAnnouncementBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runBatch5);
  } else {
    runBatch5();
  }

})();


/* ============================================================
   BATCH 6 JS — BLOG + SEARCH + 404 ENHANCEMENTS
   ============================================================ */

(function() {
  'use strict';

  /* ----------------------------------------------------------
     1. BLOG: Add "Read Article" CTA to featured post if missing
     ---------------------------------------------------------- */
  function addFeaturedPostCTA() {
    const featuredPost = document.querySelector('.juice-featured-post');
    if (!featuredPost) return;

    // Check if CTA already exists
    const existingBtn = featuredPost.querySelector('.btn');
    if (existingBtn) return;

    // Get the link from the featured post title or image
    const titleLink = featuredPost.querySelector('a[href*="/blogs/"]');
    if (!titleLink) return;
    const href = titleLink.getAttribute('href');

    // Create CTA button
    const cta = document.createElement('a');
    cta.href = href;
    cta.className = 'btn';
    cta.textContent = 'Read Article';
    cta.setAttribute('aria-label', 'Read featured article');
    cta.style.cssText = 'margin-top: 20px; display: inline-block;';

    // Insert after the excerpt/paragraph
    const excerpt = featuredPost.querySelector('p:last-of-type, .excerpt, [class*="excerpt"]');
    if (excerpt) {
      excerpt.parentNode.insertBefore(cta, excerpt.nextSibling);
    } else {
      const titleEl = featuredPost.querySelector('.article__title, h2');
      if (titleEl) titleEl.parentNode.appendChild(cta);
    }
  }

  /* ----------------------------------------------------------
     2. BLOG: Keyboard navigation for filter tabs
     ---------------------------------------------------------- */
  function initBlogTabKeyboard() {
    const tabContainers = document.querySelectorAll('.juice-blog-tabs, .juice-blog-filter, [class*="blog-filter"]');
    tabContainers.forEach(container => {
      const tabs = [...container.querySelectorAll('a')];
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('keydown', (e) => {
          let target = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            target = tabs[index + 1] || tabs[0];
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            target = tabs[index - 1] || tabs[tabs.length - 1];
          } else if (e.key === 'Home') {
            target = tabs[0];
          } else if (e.key === 'End') {
            target = tabs[tabs.length - 1];
          }
          if (target) {
            e.preventDefault();
            target.focus();
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------
     3. SEARCH: Enhance "no results" state
     ---------------------------------------------------------- */
  function enhanceSearchNoResults() {
    const noResults = document.querySelector('.search__no-results, [class*="no-results"]');
    if (!noResults) return;
    if (noResults.querySelector('.juice-no-results-enhanced')) return;

    const enhanced = document.createElement('div');
    enhanced.className = 'juice-no-results-enhanced';
    enhanced.style.cssText = 'text-align: center; padding: 40px 20px;';
    enhanced.innerHTML = '<p style="font-size:16px; color:rgb(80,80,80); margin-bottom:24px;">Try a different search term or browse our categories below.</p>' +
      '<a href="/collections/bestsellers" class="btn" style="margin-right:12px;">Shop Bestsellers</a>' +
      '<a href="/collections/skincare" class="btn" style="background:transparent; border: 2px solid rgb(42,55,67);">Skincare</a>';

    noResults.appendChild(enhanced);
  }

  /* ----------------------------------------------------------
     4. 404: Improve page accessibility
     ---------------------------------------------------------- */
  function enhance404Page() {
    if (!document.body.classList.contains('template-404')) return;

    // Add aria-live region for screen readers
    const h1 = document.querySelector('.section-header--404 h1');
    if (h1 && !h1.getAttribute('tabindex')) {
      h1.setAttribute('tabindex', '-1');
      // Auto-focus the heading for screen readers
      setTimeout(() => h1.focus(), 100);
    }

    // Ensure the "Continue shopping" link is discoverable
    const continueLink = document.querySelector('.section-header--404 a[href="/"]');
    if (continueLink && !continueLink.getAttribute('aria-label')) {
      continueLink.setAttribute('aria-label', 'Continue shopping — return to Juice Beauty homepage');
    }
  }

  /* ----------------------------------------------------------
     5. BLOG: Lazy load optimization — add loading="lazy" to off-screen blog images
     ---------------------------------------------------------- */
  function optimizeBlogImages() {
    const blogCards = document.querySelectorAll('.juice-blog-card, .juice-blog-grid article');
    blogCards.forEach((card, index) => {
      const img = card.querySelector('img');
      if (img && index > 3) {
        img.setAttribute('loading', 'lazy');
        if (!img.getAttribute('alt') || img.getAttribute('alt').trim() === '') {
          const title = card.querySelector('h2, h3, .article__title');
          if (title) img.setAttribute('alt', title.textContent.trim());
        }
      }
    });
  }

  /* ----------------------------------------------------------
     INIT
     ---------------------------------------------------------- */
  function initBatch6() {
    addFeaturedPostCTA();
    initBlogTabKeyboard();
    enhanceSearchNoResults();
    enhance404Page();
    optimizeBlogImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBatch6);
  } else {
    initBatch6();
  }

})();
